/**
 * SignupEntryPage — A-1. 회원가입 진입 화면
 * 진입: 랜딩페이지 [회원가입] 버튼
 * SNS 버튼은 SnsLoginPage와 동일한 handleSns 로직(useSnsAuthPopup) 공유 — 텍스트만 다름.
 * [인디피아 아이디로 가입] → /signup/id (기존 가입 유형 선택 화면)
 */
import { useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { Alert, Button } from '@indipia/ui-core';
import { AuthLayout } from '../../app/layouts/AuthLayout';
import { SnsBtnGroup } from '../components/SnsBtn';
import { OrDivider } from '../components/OrDivider';
import { useSnsAuthPopup } from '../hooks/useSnsAuthPopup';

export function SignupEntryPage() {
  const navigate = useNavigate();
  const { loadingProvider, snsError: hookError, handleSns, anyLoading } = useSnsAuthPopup();
  const [localError, setLocalError] = useState<string | null>(null);
  const snsError = hookError ?? localError;

  return (
    <AuthLayout
      kicker="Interior AI Platform"
      title="회원가입"
      subtitle={
        <>
          평소 쓰시던 <strong className="font-semibold text-text">카카오·네이버·구글</strong>로,<br />
          사업자정보만 입력하면 쉽게 가입할 수 있어요.
        </>
      }
      topRight={
        <Button variant="primary" onClick={() => void navigate('/login')}>
          스튜디오 입장하기 →
        </Button>
      }
    >
      {snsError && <Alert kind="error" className="mb-md">{snsError}</Alert>}

      {/* SNS 버튼 3개 */}
      <SnsBtnGroup
        onClick={(provider) => { setLocalError(null); void handleSns(provider); }}
        loadingProvider={loadingProvider}
        anyLoading={anyLoading}
        labelSuffix="빠른 가입"
      />

      <OrDivider />

      {/* 인디피아 아이디로 가입 */}
      <Button variant="primary" size="lg" className="w-full" onClick={() => void navigate('/signup/id')}>
        인디피아 아이디로 가입
      </Button>

      {/* 약관 */}
      <div className="mt-06 flex items-center justify-center">
        <Link
          to="/terms"
          className="border-b border-border pb-px text-caption text-text-disabled transition-colors hover:text-text-secondary"
        >
          이용약관
        </Link>
        <span className="mx-03 text-caption text-text-disabled">·</span>
        <Link
          to="/privacy"
          className="border-b border-border pb-px text-caption text-text-disabled transition-colors hover:text-text-secondary"
        >
          개인정보처리방침
        </Link>
      </div>
    </AuthLayout>
  );
}
